import { useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const skippedText = (s) => [[s.working, "already working"], [s.time_off, "on time off"], [s.unavailable, "unavailable"]]
  .filter(([n]) => n).map(([n, w]) => `${n} ${w}`).join(", ");

export const OfferShift = ({ shift }) => {
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);
  const [offered, setOffered] = useState(!!shift.offered_at);
  const check = async () => {
    try {
      setPreview((await api.get(`/biz/shifts/${shift.id}/offer`)).data);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const send = async () => {
    setSending(true);
    try {
      const { data } = await api.post(`/biz/shifts/${shift.id}/offer`);
      toast.success(data.demo ? `Demo: would alert ${data.offered} free staff` : `Offer sent to ${data.offered} free staff by notification and email`);
      setPreview(null);
      setOffered(true);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSending(false);
    }
  };
  return (
    <div className="space-y-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm" data-testid="offer-shift-panel">
      {!preview ? (
        <Button type="button" variant="outline" className="w-full rounded-full bg-white" onClick={check} data-testid="offer-shift-btn">
          <Megaphone className="mr-1 h-4 w-4" />{offered ? "Offer again to free staff" : "Offer to free staff"}
        </Button>
      ) : (
        <>
          <p className="font-semibold text-amber-900" data-testid="offer-eligible-count">{preview.eligible.length} free staff: {preview.eligible.map((u) => u.name).join(", ") || "nobody"}</p>
          {skippedText(preview.skipped) && <p className="text-xs text-amber-800" data-testid="offer-skipped">Not alerted: {skippedText(preview.skipped)}</p>}
          <div className="flex gap-2">
            <Button type="button" size="sm" className="rounded-full" disabled={sending || !preview.eligible.length} onClick={send} data-testid="offer-send-btn">{sending ? "Sending…" : "Send offer"}</Button>
            <Button type="button" size="sm" variant="ghost" onClick={() => setPreview(null)} data-testid="offer-cancel-btn">Cancel</Button>
          </div>
        </>
      )}
    </div>
  );
};
